import { TERM_CLASS_IDS } from "../../utils/Constant";

export enum CODE {
    XET_NGHIEM = 'xetnghiem',
    CDHA = 'chandoanhinhanh',
    TDCN = 'thamdochucnang',
    PT = 'phauthuat1',
    TT = 'thuthuat',
}

export enum KEY_TAB_DICH_VU {
    CHI_DINH_DV = '0',
    DA_CHI_DINH_DV = '1',
}

export const CODE_LOAI_PHIEU = {
    MAU_PHIEU_DIEU_TRI: 1,
    PHIEU_DIEU_TRI_CU: 2,
}

export const CONTEXT_MENU_CODE = {
    THONG_TIN_BO_SUNG: "thongTinBoSung",
};

export const TERMS_CLASS_ID_DICH_VU = [
    TERM_CLASS_IDS.KHAM_BENH,
    TERM_CLASS_IDS.XET_NGHIEM,
    TERM_CLASS_IDS.CDHA,
    TERM_CLASS_IDS.PTTT,
    TERM_CLASS_IDS.VAN_CHUYEN,
    TERM_CLASS_IDS.NGAY_GIUONG_CHUYEN_KHOA,
    TERM_CLASS_IDS.DV_KHAC
];

export const WORKFLOW_ORDER_GROUP_STATUS_CODE = {
    GUI_PHIEU: "order_group_submit",
    HUY_GUI_PHIEU: "order_group_cancel",
}

export const SERVICE_CONTEXT_MENU_OPTIONS: any[] = [
	{
		title: 'Dịch vụ',
	},
	{
		icon: <i className="bi bi-plus-circle"></i>,
		code: CONTEXT_MENU_CODE.THONG_TIN_BO_SUNG,
		name: 'Thông tin bổ sung dịch vụ',
	},
];